import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3 3.005v1.5m0 16.5v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.053a9 9 0 0 0 6.086.711l3.114-.732a48.5 48.5 0 0 1-.005-10.5l-3.11.732a9 9 0 0 1-6.085-.71l-.108-.054a9 9 0 0 0-6.208-.682L3 4.505m0 10.5v-10.5"
    }, null, -1)
  ])))
}
export default { render: render }